module.exports = __webpack_public_path__ + "static/media/Landing-BG-mobile.b365caf5.jpg";